import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import {
  fetchComponentsInitAction,
  updateComponentsFiltersAction,
  updateSelectedComponentAction,
  getComponentSuccessAction,
} from '../../../../../actions/instances/components';
import FullPageLoader from '../../../../atoms/FullPageLoader/FullPageLoader';
import EmptyView from '../../../../molecules/EmptyView/EmptyView';
import DynastySelector from '../../../../atoms/DynastySelector/DynastySelector';
import CitySelector from '../../../../atoms/CitySelector/CItySelector';
import TagsSelector from '../../../../atoms/TagsSelector/TagsSelector';
import Sidebar from '../../../../molecules/Sidebar/Sidebar';
import Icon from '../../../../atoms/Icon/Icon';
import ListItem from '../../../../molecules/ListItem/ListItem';
import ListBase from '../../../../Organisms/ListBase/ListBase';
import './ListComponents.scss';

const ListComponents = () => {
  const {
    isLoadingComponents,
    didLoadComponents,
    components,
    filters,
  } = useSelector(state => state.buildingComponentInstance);
  const isFiltersDirty = filters.dynasties.length > 0
    || filters.cities.length > 0
    || filters.tags.length > 0;
  const dispatch = useDispatch();
  const history = useHistory();
  if (!didLoadComponents && !isLoadingComponents) {
    dispatch(fetchComponentsInitAction());
  }
  if (isLoadingComponents) {
    return <FullPageLoader />;
  }
  const extractImage = (component) => {
    const defaultImage = '/images/default.jpg';
    if (component.images === null) {
      return defaultImage;
    }
    if (component.images.length === 0) {
      return defaultImage;
    }
    return component.images[0].url;
  };
  return (
    <>
      {
        components.length === 0 && !isFiltersDirty
          ? (
            <EmptyView
              message="Looks like there's no building components here yet."
              action={() => {
                history.push('/instances/building-components/create');
              }}
            />
          ) : (
            <div className="components-page-content">
              <div className="row actions-container">
                <h4 className="mb-4">Components Filters</h4>
                <div className="filters">
                  <div className="actions">
                    <div className="filter-item">
                      <DynastySelector
                        isMulti
                        onChanged={(val) => {
                          filters.dynasties = val.map(dynasty => dynasty.value);
                          dispatch(updateComponentsFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <CitySelector
                        isMulti
                        onChanged={(val) => {
                          filters.cities = val.map(city => city.value);
                          dispatch(updateComponentsFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <TagsSelector
                        isMulti
                        onChanged={(val) => {
                          filters.tags = val.map(tag => tag.value);
                          dispatch(updateComponentsFiltersAction(filters));
                        }}
                      />
                    </div>
                  </div>
                  <Button variant="default" onClick={() => history.push('/instances/building-components/create')}>
                    <Icon icon="plus" color="#000" />
                  </Button>
                </div>
              </div>
              <div className="row components-list">
                <div className="col-md-9">
                  {components && components.length > 0 ? (
                    <ListBase>
                      {components.map(component => (
                        <ListItem
                          imgSrc={extractImage(component)}
                          name={component.name}
                          code={component.code}
                          dynasty={component.dynasty.name}
                          location={`${component.city.name} [${component.city.country.code}-${component.city.code}]`}
                          creationDate={component.created_at}
                          onViewClicked={() => {
                            dispatch(updateSelectedComponentAction(component));
                            history.push('/instances/building-components/view');
                          }}
                          onEditClicked={() => {
                            dispatch(getComponentSuccessAction(component));
                            history.push('/instances/building-components/create');
                          }}
                          inReview={component.in_review}
                        />
                      ))}
                    </ListBase>
                  ) : (
                    <EmptyView
                      message="No components matches these filters"
                      action={() => history.push('/instances/building-components/create')}
                    />
                  )}
                </div>
                <div className="col-md-3 p-0">
                  <Sidebar />
                </div>
              </div>
            </div>
          )
      }
    </>
  );
};

export default ListComponents;
